import { ActionCenterTypes } from '@/core/interfaces/common';

import {
  TypeButtonsWrapper,
  TypeRadio,
} from './PickActionType.styles';

interface PickActionTypeProps {
  actionCenterType: ActionCenterTypes;
  backgroundColor: string;
  className?: string;
  setActionCenterType: React.Dispatch<React.SetStateAction<ActionCenterTypes>>;
  textColor: string;
}

export const PickActionType = ({
  actionCenterType,
  backgroundColor,
  className,
  setActionCenterType,
  textColor,
}: PickActionTypeProps) => {
  const {
    emailType,
    phoneType,
  } = ActionCenterTypes;

  return (
    <TypeButtonsWrapper
      aria-label="Send an email or make a phone call"
      backgroundcolor={backgroundColor}
      className={`muster-channel-control ${className}`.trim()}
      role="radiogroup"
    >
      <TypeRadio
        backgroundcolor={backgroundColor}
        textcolor={textColor}
        checked={actionCenterType === emailType}
        htmlFor="radioEmail"
      >
        <span aria-hidden="true">Email</span>
        <input
          aria-label="Send an advocacy email message"
          checked={actionCenterType === emailType}
          id="radioEmail"
          name="radioActionCenterType"
          onChange={() => setActionCenterType(emailType)}
          type="radio"
          value="email"
        />
      </TypeRadio>
      <TypeRadio
        backgroundcolor={backgroundColor}
        textcolor={textColor}
        checked={actionCenterType === phoneType}
        htmlFor="radioPhone"
      >
        <span aria-hidden="true">Phone</span>
        <input
          aria-label="Make an advocacy phone call"
          checked={actionCenterType === phoneType}
          id="radioPhone"
          name="radioActionCenterType"
          onChange={() => setActionCenterType(phoneType)}
          type="radio"
          value="phone"
        />
      </TypeRadio>
    </TypeButtonsWrapper>
  );
};

PickActionType.defaultProps = {
  className: '',
};
